export default "__VITE_ASSET__3910c650__"